export default "__VITE_ASSET__DUntbIX5__"